import React, { useState, useRef, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { v4 as uuidv4 } from "uuid";
import { ContextApi } from "../../../App";

function FileInput({ onMoveUp, onMoveDown, onElementDelete, preset }) {
  // States
  const [element, setElement] = useState({
    id: uuidv4(),
    type: "file",
    properties: {
      label: "Input Element",
      accept: "",
      required: true,
      size: 100
    },
    fillableByCandidate: true,
    fillableByHR: false,
    disableField: false,
    extensions: {
      pdf: false,
      jpg: false,
      docx: false,
      jpeg: false,
      png: false,
      mp4: false
    }
  });
  const [modal, setModal] = useState(false);
  const contextData = useContext(ContextApi);
  // Refs
  const elementLabelRef = useRef();
  const fillableCandidateRef = useRef();
  const fillableHRRef = useRef();
  const elementRequiredRef = useRef();
  const elementSizeRef = useRef();
  const elementRangeRef = useRef();
  //  const disableFieldRef = useRef();
  const pdfRef = useRef();
  const jpgRef = useRef();
  const jpegRef = useRef();
  const docRef = useRef();
  const pngRef = useRef();
  const mp4Ref = useRef();

  // Effects
  useEffect(() => {
    if (preset !== null && preset && preset !== undefined) {
      setElement((previousState) => {
        return { ...previousState, ...preset };
      });
    }
  }, [preset]);

  // Events
  const toggle = () => setModal(!modal);

  function onEdit() {
    setElement((previousState) => {
      previousState.properties.label = elementLabelRef.current.value;
      previousState.properties.size = elementSizeRef.current.value;
      previousState.properties.required = elementRequiredRef.current.checked;
      previousState.fillableByCandidate = fillableCandidateRef.current.checked;
      previousState.fillableByHR = fillableHRRef.current.checked;
      previousState.fillableByHR = fillableHRRef.current.checked;
      //   previousState.disableField = disableFieldRef.current.checked;
      previousState.extensions.docx = docRef.current.checked;
      previousState.extensions.pdf = pdfRef.current.checked;
      previousState.extensions.png = pngRef.current.checked;
      previousState.extensions.jpg = jpgRef.current.checked;
      previousState.extensions.jpeg = jpegRef.current.checked;
      previousState.extensions.mp4 = mp4Ref.current.checked;
      return previousState;
    });
    toggle();
    contextData.setContextData({
      ...contextData.contextData,
      isEdit: !contextData.contextData.isEdit
    });
  }

  function kbToMb(kb) {
    return Number(kb / 1024).toFixed(2);
  }

  return (
    <div
      className="form-group form-builder-element mb-3"
      data={JSON.stringify(element)}>
      <button
        className="btn btn-danger btn-circle btn-sm mr-2 btn-builder-right"
        onClick={(e) => onElementDelete(e, element)}>
        <i className="fa fa-trash"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={toggle}>
        <i className="fa fa-asterisk"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveUp}>
        <i className="fa fa-chevron-up"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveDown}>
        <i className="fa fa-chevron-down"></i>
      </button>
      <label>
        {element.properties.label}
        {element.properties.required && <span style={{ color: "red" }}>*</span>}
        ( Format -
        {element.properties.accept} )(Size - {kbToMb(Number(element.properties.size))} MB)
      </label>
      <input
        className="form-control"
        type="file"
        accept={element.properties.accept}
        placeholder={element.properties.placeholder}
      />
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit Text Field Properties</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Label</label>
            <input
              ref={elementLabelRef}
              type="text"
              className="form-control"
              defaultValue={element.properties.label}
            />
          </div>
          <div className="row mt-2">
            <div className="col-4">
              <div className="custom-control custom-checkbox">
                <input
                  ref={pdfRef}
                  type="checkbox"
                  className="custom-control-input"
                  id="pdf"
                  value=".pdf"
                  defaultChecked={element.extensions.pdf}
                />
                <label className="custom-control-label" htmlFor="pdf">
                  PDF
                </label>
              </div>
            </div>
            <div className="col-4">
              <div className="custom-control custom-checkbox">
                <input
                  ref={jpegRef}
                  type="checkbox"
                  className="custom-control-input"
                  value=".jpeg"
                  id="jpeg"
                  defaultChecked={element.extensions.jpeg}
                />
                <label className="custom-control-label" htmlFor="jpeg">
                  JPEG
                </label>
              </div>
            </div>
            <div className="col-4">
              <div className="custom-control custom-checkbox">
                <input
                  ref={jpgRef}
                  type="checkbox"
                  className="custom-control-input"
                  value=".jpg"
                  id="jpg"
                  defaultChecked={element.extensions.jpg}
                />
                <label className="custom-control-label" htmlFor="jpg">
                  JPG
                </label>
              </div>
            </div>
          </div>
          <div className="row mt-2 mb-4">
            <div className="col-4">
              <div className="custom-control custom-checkbox">
                <input
                  ref={pngRef}
                  type="checkbox"
                  className="custom-control-input"
                  id="png"
                  value=".png"
                  defaultChecked={element.extensions.png}
                />
                <label className="custom-control-label" htmlFor="png">
                  PNG
                </label>
              </div>
            </div>
            <div className="col-4">
              <div className="custom-control custom-checkbox">
                <input
                  ref={docRef}
                  type="checkbox"
                  className="custom-control-input"
                  id="docx"
                  value=".docx"
                  defaultChecked={element.extensions.docx}
                />
                <label className="custom-control-label" htmlFor="docx">
                  DOC
                </label>
              </div>
            </div>
            <div className="col-4">
              <div className="custom-control custom-checkbox">
                <input
                  ref={mp4Ref}
                  type="checkbox"
                  className="custom-control-input"
                  id="mp4"
                  value=".mp4"
                  defaultChecked={element.extensions.mp4}
                />
                <label className="custom-control-label" htmlFor="mp4">
                  MP4
                </label>
              </div>
            </div>
          </div>
          <div className="form-group">
            <label>Enter Size in KB (Defalt : 100kb)</label>
            <input
              ref={elementSizeRef}
              type="number"
              className="form-control"
              defaultValue={element.properties.size}
            />
          </div>
          {/* <div className="custom-control custom-checkbox" style={{display:'flex',alignItems:'center',gap:'1rem'}}>
            <label for="fileSize" className="mb-0">File Size</label>
            <input type="range" id="fileSize" defaultValue={1} ref={elementRangeRef}/>
          </div> */}
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={elementRequiredRef}
              className="custom-control-input"
              id="requiredCheck"
              defaultChecked={element.properties.required}
            />
            <label className="custom-control-label" htmlFor="requiredCheck">
              Mandatory?
            </label>
          </div>
          {/* <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={elementRequiredRef}
              className="custom-control-input"
              id="requiredCheck"
              defaultChecked={element.properties.dataType}
            />
          </div> */}

          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={fillableCandidateRef}
              className="custom-control-input"
              id="fillableCandidate"
              defaultChecked={element.fillableByCandidate}
            />
            <label className="custom-control-label" htmlFor="fillableCandidate">
              Can candidates edit this field?
            </label>
          </div>

          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={fillableHRRef}
              className="custom-control-input"
              id="fillableHR"
              defaultChecked={element.fillableByHR}
            />
            <label className="custom-control-label" htmlFor="fillableHR">
              Can HRs edit this field?
            </label>
          </div>
          {/* <div className="custom-control custom-checkbox">
            <input
              ref={disableFieldRef}
              type="checkbox"
              className="custom-control-input"
              id="disableField"
              defaultChecked={element.disableField}
            />
            <label className="custom-control-label" htmlFor="disableField">
              Disable preFilled Field(only admin can edit)
            </label>
          </div> */}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onEdit}>
            Update
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default FileInput;
